export default "__VITE_ASSET__DgMX0om5__"